import i18n from 'src/config/i18n';

/*
    before: ['qwe', 'asd', 'zxc']
    after: 'qwe, asd and zxc'
    after with shouldCapitalize: 'Qwe, Asd and Zxc'
    after with shouldCapitalize in spanish: 'Qwe, Asd y Zxc'
*/

export const formatStringsArrayWithAnd = (strings: string[]): string =>
    strings.reduce(
        (acc, _string, i) =>
            i === 0
                ? ` ${_string}`
                : `${acc}${i < strings.length - 1 ? ', ' : `, ${i18n.t('common.and')} `}${_string}`,
        '',
    );
